"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fields = void 0;
var _uiKit = require("@cian/ui-kit");
var _utils = require("@cian/utils");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./Fields.css"));
var _Tooltip = require("../Tooltip");
var _clsx = require("clsx");
var _InfoIcon = require("../InfoIcon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Fields = _ref => {
  let {
    onPriceChange,
    onPaymentPeriodChange,
    onInitialPaymentChange,
    onShowEscrowToggle,
    maxPrice,
    minPrice,
    price,
    initialPayment,
    initialPaymentPercent,
    paymentPeriod,
    showEscrow,
    priceTooltipTitle,
    priceTooltipText,
    escrowTooltipTitle,
    escrowTooltipText
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['fields']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['field']
  }, /*#__PURE__*/React.createElement(_uiKit.FormField, {
    label: "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",
    withoutMargin: true
  }, /*#__PURE__*/React.createElement(_uiKit.InputSlider, {
    value: price,
    onChange: onPriceChange,
    rightAdornment: /*#__PURE__*/React.createElement(_uiKit.InputAdornment, null, "\u20BD"),
    min: minPrice,
    max: maxPrice,
    step: 100000
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['price-tooltip']
  }, /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    title: priceTooltipTitle,
    content: priceTooltipText
  }, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_InfoIcon.InfoIcon, null)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true,
    phone: true
  }, /*#__PURE__*/React.createElement(_uiKit.IconFunctionalInformationCircle16, {
    color: "primary_100"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: styles['field']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['percent']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    as: "span",
    color: "black_60"
  }, initialPaymentPercent, "%")), /*#__PURE__*/React.createElement(_uiKit.FormField, {
    label: "\u041F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u0437\u043D\u043E\u0441",
    withoutMargin: true
  }, /*#__PURE__*/React.createElement(_uiKit.InputSlider, {
    value: initialPayment,
    onChange: onInitialPaymentChange,
    rightAdornment: /*#__PURE__*/React.createElement(_uiKit.InputAdornment, null, "\u20BD"),
    min: 0,
    max: price,
    step: 100000
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['field']
  }, /*#__PURE__*/React.createElement(_uiKit.FormField, {
    label: "\u0421\u0440\u043E\u043A",
    withoutMargin: true
  }, /*#__PURE__*/React.createElement(_uiKit.InputSlider, {
    value: paymentPeriod,
    onChange: onPaymentPeriodChange,
    rightAdornment: /*#__PURE__*/React.createElement(_uiKit.InputAdornment, null, (0, _utils.plural)(paymentPeriod, ['год', 'года', 'лет'])),
    min: 1,
    max: 30,
    step: 1
  }))), /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.clsx)(styles['field'], styles['switch'])
  }, /*#__PURE__*/React.createElement(_uiKit.Switch, {
    checked: showEscrow,
    onChange: onShowEscrowToggle,
    label: "\u0421 \u044D\u0441\u043A\u0440\u043E\u0443-\u0441\u0447\u0451\u0442\u043E\u043C"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['escrow-tooltip']
  }, /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    title: escrowTooltipTitle,
    content: escrowTooltipText
  }, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_InfoIcon.InfoIcon, null)), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true,
    phone: true
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    as: "p",
    role: "button",
    color: "primary_100"
  }, "\u0427\u0442\u043E \u0442\u0430\u043A\u043E\u0435 \u044D\u0441\u043A\u0440\u043E\u0443-\u0441\u0447\u0451\u0442?"))))));
};
exports.Fields = Fields;